"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
//
// styles
//
const StyledModalButton_1 = require("../StyledModalButton");
const ModalButton = (props) => {
    function handleCopy() {
        navigator.clipboard.writeText(props.orderNumber);
    }
    return react_1.default.createElement(StyledModalButton_1.StyledModalButton, { onClick: handleCopy }, "Copy");
};
ModalButton.propTypes = {
    orderNumber: prop_types_1.default.string
};
exports.default = ModalButton;
